import { Styles } from 'react-jss'
import { createUseStyles } from '../../web-styles'

interface FormFieldStyles {
  container: Styles
  children: Styles
  errorContainer: Styles
}

const ERROR_CONTAINER_HEIGHT = 20

export const useStyles = createUseStyles<FormFieldStyles>((theme) => {
  return {
    container: {
      display: 'flex',
      flexDirection: 'column',
    },
    children: {
      width: '100%',
      marginTop: theme.calcUnit(theme.spacing.s2),
    },
    errorContainer: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: theme.calcUnit(theme.spacing.s1),
      height: theme.calcUnit(ERROR_CONTAINER_HEIGHT),
    },
  }
})
